import React from 'react';
import { Redirect } from 'react-router-dom';
import { isQuestionCategorySubscribable } from '../../../data/filters/questions/isQuestionCategorySubscribable';
import resolvePath from '../../../misc/resolvePath';
import ButtonLink from '../../elements/ButtonLink';
import EmptyScreenContentPlaceholder from '../../elements/EmptyScreenContentPlaceholder/EmptyScreenContentPlaceholder';
import Icon from '../../elements/icons/Icon';
import Link from '../../elements/Link';
import ScreenTitle from '../../elements/ScreenTitle/ScreenTitle';
import ScrollableList from '../../elements/ScrollableList';
import SearchBar from '../../elements/SearchBar2';
import ToolbarLayout from '../../elements/ToolbarLayout';
import ToolbarButton from '../../elements/ToolbarButtons/ToolbarButton';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import Screen from '../Screen';
import CategoriesTabs from './common/CategoriesTabs';
import connectQuests from './common/connectQuests';
import EventQuestQuestionListItem from './EventQuestQuestionListItem/EventQuestQuestionListItem';
import { escapeRegExp } from 'lodash';
import { isQuestionCategoryPostable } from '../../../data/filters/questions/isQuestionCategoryPostable';
import PostQuestFooterButton from './common/PostQuestFooterButton';

class EventQuests extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSearchVisible: false,
            filter: '',
        };
    }
    componentDidMount() {
        this.props.notifications.forEach((notif) => {
            app.api.notifications.markRead(notif.id);
        });
    }
    render() {
        if (!this.props.category) {
            return <Redirect to={resolvePath(location.pathname, '..')} />;
        }

        let { i18n, event, categories, category } = this.props,
            toolbarIcons = _([
                this.props.subscribableCategories.length ? <ToolbarButton src="img/ellipsis-horizontal.png" key="more" href="./categories" /> : null,
                !this.state.isSearchVisible ? <ToolbarButton src="img/search_icon.png" key="search" onClick={this.handleToggleSearchVisibility.bind(this)} /> : null,
            ])
                .compact()
                .value(),
            header = (
                <div className="header">
                    <TopBarEvent event={event} returnURL={['/events', this.props.eventId].join('/')} qa={true} />
                    <ScreenTitle screen={i18n['label.questions']} event={event} />
                    <ToolbarLayout>
                        <CategoriesTabs {...this.props} />
                        {toolbarIcons}
                    </ToolbarLayout>
                    {this.state.isSearchVisible ? <SearchBar i18n={i18n} onChange={this.handleSearchChange.bind(this)} onClose={this.handleToggleSearchVisibility.bind(this)} /> : null}
                    {this.props.qcatId == 'all' && event.settings.default_question_explainer ? (
                        <div className="content whitebg">
                            {event.settings.default_question_explainer.split('\n').map((line, i) => (
                                <p key={i} className="text hint">
                                    {line}
                                </p>
                            ))}
                        </div>
                    ) : null}
                    {this.props.category.id ? (
                        <div
                            className="block"
                            style={{
                                background: 'white',
                                minHeight: 50,
                                cursor: 'default',
                            }}>
                            <Link href={this.props.category.info_hyperlink ?? './participants'}>
                                <Icon
                                    src="img/event_participants.png"
                                    color={event.settings.secondary_color}
                                    size={25}
                                    style={{
                                        position: 'absolute',
                                        top: 12,
                                        right: 10,
                                    }}
                                />
                            </Link>
                            <h4
                                style={{
                                    color: event.settings.secondary_color,
                                }}>
                                {this.props.category.title}
                            </h4>
                            <div className="subtitle">{this.props.category.description}</div>
                        </div>
                    ) : null}
                    <hr />
                </div>
            ),
            footer = (
                <div className="content">
                    <PostQuestFooterButton event={event} />
                </div>
            ),
            questionsFilterExpr = this.state.filter ? new RegExp(escapeRegExp(this.state.filter), 'i') : null,
            questionsFilter = this.state.filter
                ? (q) => {
                      return q.content.match(questionsFilterExpr);
                  }
                : _.identity,
            filteredQuestions = _(this.props.questions).filter(questionsFilter).value(),
            content = filteredQuestions.length ? (
                <ScrollableList className="" savePosition={'eventQuestions-' + this.props.eventId + '-' + this.props.qcatId}>
                    {filteredQuestions.map((question) => (
                        <EventQuestQuestionListItem event={event} question={question} key={question.id} showTagsOnList={this.props.showTagsOnList} />
                    ))}
                </ScrollableList>
            ) : (
                <EmptyScreenContentPlaceholder
                    event={event}
                    icon="/img/event_qa.png"
                    title={i18n['label.questions']}
                    label={event._isEvent ? i18n['label.tip.no-questions-post'] : i18n['label.tip.no-questions-post-community']}
                />
            );

        if (footer && category.id && !category.subscribed && isQuestionCategorySubscribable(category)) {
            footer = (
                <div className="content">
                    <ButtonLink style={event._local.styles.button} onClick={this.handleJoinGroup.bind(this)}>
                        {i18n['question-category.join']}
                    </ButtonLink>
                </div>
            );
        }

        return (
            <Screen header={header} footer={footer}>
                {content}
            </Screen>
        );
    }
    handleJoinGroup() {
        if (this.props.category && this.props.category.id) {
            app.api.questions.joinGroup(this.props.eventId, this.props.category.id);
        }
    }
    handleSearchChange(value) {
        this.setState({ filter: value });
    }
    handleToggleSearchVisibility() {
        this.setState({
            isSearchVisible: !this.state.isSearchVisible,
            filter: null,
        });
    }
    handleToggleCategoriesScreen() {
        app.history.push(resolvePath(app.history.location.pathname, 'categories'));
    }
}

const ConnectedEventQuests = connectQuests(EventQuests);

export default (props) => <ConnectedEventQuests {...props.match.params} />;
